import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Company } from '../../company/company.model';
import { Customer } from '../customer.model';
import { SessionStorageService } from '../../services/session-storage.service';
import { PartyQuickCreateDialogComponent, PartyQuickCreateResult } from '../../shared/party-quick-create/party-quick-create-dialog.component';

@Component({
    selector: 'app-customer-form',
    templateUrl: './customer-form.component.html',
    styleUrls: ['./customer-form.component.css'],
    standalone: true,
    imports: [
        CommonModule,
        PartyQuickCreateDialogComponent
    ]
})
export class CustomerFormComponent {
    private completedThisCycle = false;

    @Input() displayModal = false;
    @Input() dialogHeader = '';
    @Input() submitButtonLabel = '';
    @Input() customer: Customer = new Customer();
    @Input() company: Company = new Company();
    @Input() isEmployee = false;
    @Input() companyRequired = true;
    @Output() modalClosed = new EventEmitter<Customer | boolean>();

    constructor(private readonly sessionStorageService: SessionStorageService) {}

    get mode(): 'customer' | 'employee' {
        return this.isEmployee ? 'employee' : 'customer';
    }

    get owningCompany(): Company | null {
        return this.sessionStorageService.getCompany() ?? null;
    }

    get linkedCompany(): Company | null {
        return this.company?.id ? this.company : this.customer?.company?.id ? this.customer.company : null;
    }

    get countries() {
        return this.sessionStorageService.getCountryList() ?? [];
    }

    onDialogCompleted(result: PartyQuickCreateResult): void {
        this.completedThisCycle = true;
        this.modalClosed.emit(result.record as Customer);
    }

    onVisibilityChanged(visible: boolean): void {
        this.displayModal = visible;
        if (!visible && !this.completedThisCycle) {
            this.modalClosed.emit(false);
        }
        if (visible) {
            this.completedThisCycle = false;
        }
    }

    onDialogFailed(): void {
        this.completedThisCycle = false;
    }
}
